module.exports = __webpack_public_path__ + "static/media/short-06.675ed718.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/short/short-06.png
// module id = 2118
// module chunks = 0